import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';

export const ActionContainer = styled.div<{ $disabled?: boolean }>`
    align-items: center;
    color: ${(props) => (props.$disabled ? theme.colors.foreground.disabled : theme.colors.foreground.subtle)};
    display: flex;
    flex: none;
    justify-content: center;
    min-width: 0;
`;
